export const VALID_PRODUCTION_STATUS_FOR_CAMPAIGNS = ['Draft', 'Published'];
export const ALLOWED_PRODUCTION_AUTHED_STATUS = ['Granted', 'Expiring Soon'];

export default {
  VALID_PRODUCTION_STATUS_FOR_CAMPAIGNS,
};
